export default __webpack_public_path__ + "media/images/evangelion-66553f1ec439dce9999b1220e9c86fd6.jpg";